module.exports = __webpack_public_path__ + "img/card-basic-rivoneed.0d5d96fc.webp";